import type { User } from "@/types/auth";

const STORAGE_KEY = "twin_user";

function get(): User | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as User) : null;
  } catch {
    return null;
  }
}

function set(user: User) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
}

function clear() {
  localStorage.removeItem(STORAGE_KEY);
}

export const userStorage = {
  get,
  set,
  clear,
};
